'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof String.prototype.padStart === 'function' ? String.prototype.padStart : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/string.prototype.padstart/polyfill.js
// module id = 18
// module chunks = 0